module.exports = __webpack_public_path__ + "img/product-hot.968f6b15.png";